export default function TeamTab() {
  return <div>Team Tab</div>;
}
